<template>
  <div>
    <Breadcrumbs main="shifts" title="New shift" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-header">
              <h5>Add new shift</h5>
            </div>
            <div class="card-body">
              <form-wizard
                color="#4466f2"
                :start-index="0"
                title="Please fill data"
                subtitle="All time you can get back to previous tab"
                back-button-text="Go back!"
                next-button-text="Go next!"
                finish-button-text="We're there"
                @on-complete="addShift"
              >
                <tab-content title="Basic data">
                  <div class="setup-content" id="step-1">
                    <div class="col-xs-12">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="control-label">Coordinator name</label>
                          <input
                            class="form-control"
                            type="text"
                            v-model="currentUser"
                            required="required"
                            disabled
                          />
                        </div>
                                                <div class="form-group">
                          <label class="control-label">Shift system</label>
                          <b-form-select
                            :options="shiftsType"
                            :selected="form.drivingSys"
                            v-model="form.drivingSys"
                          ></b-form-select>
                        </div>
                        <label class="control-label">Select car</label>
                        <div class="form-group m-t-15 custom-radio-ml">
                          <div class="radio radio-primary">
                            <b-form-radio
                              v-for="car in getActiveCars"
                              :key="car.id"
                              :value="{ id: car.id, regPlate: car.regPlate, mileage: car.mileage }"
                              v-model="form.selectedCar"
                              >{{ car.regPlate }}</b-form-radio
                            >
                          </div>
                        </div>
                        <label class="control-label" v-if="this.form.drivingSys">Recieving vehcile</label>
                        <div class="form-group m-t-15 custom-radio-ml" v-if="this.form.drivingSys">
                          <div class="radio radio-primary">
                            <b-form-radio
                              v-for="user in getActiveUsers"
                              :key="user.id"
                              :name="user.firstName + ' ' + user.lastName"
                              :value="{
                                id: user.id,
                                fullName: user.firstName + ' ' + user.lastName,
                              }"
                              v-model="form.selectedPassing"
                              >{{
                                `${user.lastName} ${user.firstName}`
                              }}</b-form-radio
                            >
                          </div>
                        </div>

                        <div class="form-group">
                          <label class="control-label">Date</label>
                          <input
                            class="form-control"
                            type="date"
                            v-model="form.date"
                            required="required"
                          />
                        </div>

                        <div class="form-group" v-if="form.drivingSys === '3Z'">
                          <label class="control-label">Shift</label>
                          <b-form-select
                            :options="shiftOptions"
                            :selected="form.shift"
                            v-model="form.shift"
                          ></b-form-select>
                        </div>
                        <div v-if="form.drivingSys === '2Z'">
                          <label class="control-label">Second driver</label>
                          <div class="form-group m-t-15 custom-radio-ml">
                            <div class="radio radio-primary">
                              <b-form-radio
                                v-for="user in getSecondDriver"
                                :key="user.id"
                                :name="user.firstName + ' ' + user.lastName"
                                :value="{
                                  id: user.id,
                                  fullName:
                                    user.firstName + ' ' + user.lastName,
                                }"
                                v-model="form.secondDriver"
                                >{{
                                  `${user.lastName} ${user.firstName}`
                                }}</b-form-radio
                              >
                            </div>
                          </div>
                        </div>
                        <div class="form-group">
                          <label class="control-label">Current mileage</label>
                          <input
                            class="form-control"
                            type="number"
                             v-model="form.selectedCar.mileage"
                          />
                        </div>
                        <div class="form-group" v-if="form.drivingSys && form.drivingSys !== '3Z'">
                          <label class="control-label">Week limit</label>
                          <input
                            class="form-control"
                            type="number"
                            v-model="selectedSystem"
                          />
                        </div>
                        <div class="form-group">
                          <label class="control-label"
                            >Track recording working?</label
                          >
                          <b-form-select
                            :options="recordOptions"
                            v-model="form.recording"
                          ></b-form-select>
                        </div>
                        <div class="form-group">
                          <label class="control-label">Car damages</label>
                          <b-form-select
                            :options="dmgOption"
                            v-model="form.damages"
                          ></b-form-select>
                        </div>
                        <div class="form-group" v-if="this.form.damages">
                          <label class="control-label"
                            >Damage description</label
                          >
                          <input
                            class="form-control"
                            type="text"
                            v-model="form.dmgDesc"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </tab-content>
                <tab-content title="Summary">
                  <div class="setup-content" id="step-3">
                    <div class="col-xs-12">
                      <div class="col-md-12">
                        <div class="form-group"></div>
                      </div>
                    </div>
                  </div>
                </tab-content>
              </form-wizard>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>
<script>
import Docxtemplater from "docxtemplater";
import PizZip from "pizzip";
import PizZipUtils from "pizzip/utils/index.js";
import { saveAs } from "file-saver";

function loadFile(url, callback) {
  PizZipUtils.getBinaryContent(url, callback);
}
export default {
  data() {
    return {
      form: {
        shiftHandler: "",
        selectedPassing: "",
        selectedCar: "",
        date: "",
        shift: "",
        earning: "",
        money: "",
        mileage: "",
        fuel: "",
        recording: "",
        damages: false,
        dmgDesc: "",
        carWashCost: 0,
        selectedReciever: "",
        secondDriver: "",
        nextShift: "",
        drivingSys: "",
      },
      isLoading: false,
      shiftOptions: [
        { value: "Day", text: "Day" },
        { value: "Night", text: "Night" },
      ],
      recordOptions: [
        { value: "Working", text: "Yes" },
        { value: "Not working", text: "No" },
        { value: "Missing", text: "Missing video recorder" },
      ],
      dmgOption: [
        { value: true, text: "Yes" },
        { value: false, text: "No" },
      ],
      shiftsType: [
        { value: "3Z", text: "3Z Shifts" },
        { value: "2Z", text: "Partner system" },
        { value: "SOLO", text: "Solo system" },
      ],
      error: null,
    };
  },
  created() {
    this.fetchUsers();
  },
  computed: {
    currentUser() {
      let data = JSON.parse(localStorage.getItem("user"));
      return data.user.username;
    },
    getActiveUsers() {
      const drivers = this.$store.getters["users/fetchUsers"];
      const shiftDrivers = drivers.filter(item => item.active && item.drivingSys === this.form.drivingSys)
      return shiftDrivers
    },
    getSecondDriver(){
      return !this.isLoading && this.getActiveUsers.filter((item) => item.id !== this.form.selectedPassing.id)
    },
    getActiveCars() {
      return !this.isLoading && this.$store.getters["cars/getActiveCars"];
    },
    checkShift() {
      return this.form.shift === "Day" ? "Night" : "Day";
    },
    selectedSystem(){
      return this.form.drivingSys === "solo" ? 1800 : 1400;
    }
  },
  methods: {
    async addShift() {
      try{await this.$store.dispatch("shifts/addNewShift", {
        fullName: this.form.selectedPassing.fullName,
        selectedPassing: this.form.selectedPassing.id,
        selectedCar: this.form.selectedCar.id,
        regPlate: this.form.selectedCar.regPlate,
        date: this.form.date,
        shift: this.form.shift,
        mileage: this.form.selectedCar.mileage,
        damages: this.form.damages,
        dmgDesc: this.form.dmgDesc,
        carWashCost: this.form.carWashCost,
        recording: this.form.recording,
        shiftHandler: this.currentUser,
        drivingSystem: this.form.drivingSys,
        secondDriver: this.form.secondDriver.fullName,
        secondDriverId: this.form.secondDriver.id,
        milLimit: this.selectedSystem,
        active: true,
        nextDriver: false,
      });
      }
      catch (error) {
        this.error = error.message || 'Failed to add new shift.'
        this.$swal(this.error)
      } finally {
        if(this.error === null){
           this.printTemplate()
        }
       }

    },
    async fetchUsers() {
      this.isLoading = true;
      await this.$store.dispatch("users/fetchUsers");
      await this.$store.dispatch("cars/fetchCars");
      this.isLoading = false;
    },
    // render
    renderDoc() {
      const that = this
      const vehInfo = this.getActiveCars.filter((item) => item.id === this.form.selectedCar.id)
      const personDetails = this.getActiveUsers.filter((item) => item.id === this.form.selectedPassing.id)
      let currentTime = new Date().toLocaleString()
      loadFile("https://api.rightcloud.pl/uploads/autotemp_8cf2287063.docx", function(
        error,
        content
      ) {
        if (error) {
          throw error;
        }
        var zip = new PizZip(content);
        var doc = new Docxtemplater().loadZip(zip);
        doc.setData({
          date: new Date().toLocaleString(),
          regPlate: that.form.selectedCar.regPlate,
          mileage: that.form.selectedCar.mileage,
          model: vehInfo[0].make,
          make: vehInfo[0].model,
          vin: vehInfo[0].vin,
          recieving: that.form.selectedPassing.fullName,
          year: "2022",
          regDocNumber: vehInfo[0].regDocNumber,
          street: personDetails[0].street,
          city: personDetails[0].city,
          zip: personDetails[0].zip,
          idNumber: personDetails[0].identificationNum,
          engineSize: vehInfo[0].engineSize,
          drivingNum: personDetails[0].drivingLicense,
          today: currentTime,
          giving: 'Mikołaj Grendzisz'
        });
        try {
          doc.render();
        } catch (error) {
          // The error thrown here contains additional information when logged with JSON.stringify (it contains a properties object containing all suberrors).
          function replaceErrors(key, value) {
            if (value instanceof Error) {
              return Object.getOwnPropertyNames(value).reduce(function(
                error,
                key
              ) {
                error[key] = value[key];
                return error;
              },
              {});
            }
            return value;
          }
          console.log(JSON.stringify({ error: error }, replaceErrors));

          if (error.properties && error.properties.errors instanceof Array) {
            const errorMessages = error.properties.errors
              .map(function(error) {
                return error.properties.explanation;
              })
              .join("\n");
            console.log("errorMessages", errorMessages);
            // errorMessages is a humanly readable message looking like this :
            // 'The tag beginning with "foobar" is unopened'
          }
          throw error;
        }
        var out = doc.getZip().generate({
          type: "blob",
          mimeType:
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        }); //Output the document using Data-URI
        saveAs(out, `car.docx`);
        that.$swal('New shift added');
      });
    },
    printTemplate() {
      this.$swal({
        text: "Do you want to print rental agreement?",
        showCancelButton: true,
        confirmButtonText: "Yes!",
        confirmButtonColor: "#4466f2",
        cancelButtonText: "No",
        cancelButtonColor: "#efefef",
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          this.renderDoc()
        } else if (result.dismiss) {
          console.log("dissmised");
        }
      });
    },
  },
};
</script>
